export class AdminSettingPermission {
    public static readonly view: string = 'ui:view:admin-settings';
}
